import { graphql } from '../../../../graphql/generated';

export const UPDATE_PARAMETER_MUTATION = graphql(`
  mutation UpdateParameter($id: ID!, $input: ParameterUpdateInput!) {
    updateParameter(id: $id, input: $input) {
      id
    }
  }
`);

export const PARAMETER_QUERY = graphql(`
  query Parameter($id: ID!) {
    labParameter(id: $id) {
      id
      longName
      shortName
      analysisStations {
        id
      }
      specimens {
        id
      }
      withParameters {
        id
      }
      withoutParameters {
        id
      }
      insuranceDefinitions {
        id
        insurance {
          id
        }
        diagnoses {
          id
        }
        periodicGroup {
          id
        }
        lg
        deductible
      }
      specialRates {
        id
      }
      forms {
        id
      }
      deactivated
      doctorBilling
      patientBilling
      description
      billingDescription
      importantDescription
      edifactNumber
      link
      lgDoctorBilling
      storagePeriod
      evalHours
      priceDoctor
      priceLgDoctor
      pricePatient
      priceDeductible
      partnerLab
      synonyms
      acute
      volume
      loincCode
      aiDescription
    }
  }
`);
